"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabsContext = exports.TabsContextProvider = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
// Gonna do something weird here with the context default value. This will NEVER be used since
// We require the Tab, TabList, and TabPanel to be used within Tabs.
const TabsContext = (0, _lodestarUtils.createContext)({}, "TabsContext");
const TabsContextProvider = _ref => {
  let {
    children,
    disableAutoTabFocusWhenSwitching,
    manual,
    onChange,
    onlyRenderActiveTabPanelChildren,
    renderOn,
    selectedId
  } = _ref;
  const [tabRegistrations, setTabRegistrations] = (0, _react.useState)([]);
  const registerTab = (0, _react.useCallback)((tabId, ref) => {
    setTabRegistrations(prev => {
      const exists = prev.find(tab => tab.tabId === tabId);
      if (exists) {
        return prev;
      } else {
        return [...prev, {
          tabId,
          tabRef: ref,
          panelId: null,
          panelRef: null
        }];
      }
    });
    return {
      unregister: () => {
        setTabRegistrations(prev => {
          return prev.filter(tab => tab.tabId !== tabId);
        });
      }
    };
  }, []);
  const registerTabPanel = (0, _react.useCallback)((panelId, ref) => {
    // Load this panel's reg into the first open slot in the tab registrations.
    setTabRegistrations(prev => {
      const nextEmptyTabReg = prev.find(tab => !tab.panelRef);
      if (nextEmptyTabReg) {
        return prev.map(tab => {
          if (tab.tabId === nextEmptyTabReg.tabId) {
            return {
              ...tab,
              panelRef: ref,
              panelId
            };
          } else {
            return tab;
          }
        });
      }
      return prev;
    });
    return {
      unregister: () => {
        setTabRegistrations(prev => {
          return prev.map(tab => {
            if (tab.panelRef?.current && tab.panelRef.current === ref.current) {
              return {
                ...tab,
                panelRef: null
              };
            } else {
              return tab;
            }
          });
        });
      }
    };
  }, []);
  const moveFocusBy = (0, _react.useCallback)(amount => {
    const selectedIndex = tabRegistrations.findIndex(_ref2 => {
      let {
        tabRef
      } = _ref2;
      return tabRef.current === document.activeElement;
    });
    const nextIndex = selectedIndex + amount;
    if (nextIndex >= 0 && nextIndex < tabRegistrations.length) {
      if (manual) {
        tabRegistrations[nextIndex].tabRef.current?.focus();
      } else {
        onChange(tabRegistrations[nextIndex].tabId);
      }
    }
  }, [manual, onChange, tabRegistrations]);
  const focusPreviousTab = (0, _react.useCallback)(() => {
    moveFocusBy(-1);
  }, [moveFocusBy]);
  const focusNextTab = (0, _react.useCallback)(() => {
    moveFocusBy(1);
  }, [moveFocusBy]);
  const memoizedValue = (0, _react.useMemo)(() => {
    return {
      disableAutoTabFocusWhenSwitching,
      manual,
      onChange,
      onlyRenderActiveTabPanelChildren,
      registerTab,
      registerTabPanel,
      renderOn,
      selectedId,
      focusNextTab,
      focusPreviousTab,
      tabRegistrations
    };
  }, [disableAutoTabFocusWhenSwitching, manual, onChange, onlyRenderActiveTabPanelChildren, registerTab, registerTabPanel, renderOn, selectedId, focusNextTab, focusPreviousTab, tabRegistrations]);
  return /*#__PURE__*/_react.default.createElement(TabsContext.Provider, {
    value: memoizedValue
  }, children);
};
exports.TabsContextProvider = TabsContextProvider;
const useTabsContext = () => {
  return (0, _react.useContext)(TabsContext);
};
exports.useTabsContext = useTabsContext;
//# sourceMappingURL=TabsContext.js.map